module.exports = __webpack_public_path__ + "img/hover-iocn3.f325acc0.svg";